import SectionStack from 'components/common/SectionStack'
import { Body1, Body2 } from 'components/typography'
import { FC } from 'react'

const CompanyInfoSectionIsha: FC = () => {
  return (
    <SectionStack>
      <Body1 color="alabaster" pb="4px" borderBottom="2px solid #25241E">
        Sobre a Isha
      </Body1>
      <Body2 color="alabaster">
        A Isha é uma plataforma de intermediação de saúde dedicada à mulher. Ela reúne médicos, nutricionistas, personal
        trainers, psicólogos e farmácias para construir uma solução de qualidade, segura e acessível para todas. O site
        isha.com.br é gerido por OMENS SERVIÇOS ONLINE E SOFTWARE LTDA., empresa registrada no CNPJ 38.143.501/0001-08
        no Brasil, com sede em São Paulo. Seus dados são coletados e processados por um servidor de hospedagem
        certificado e aprovado.
      </Body2>
      <Body2 color="alabaster">
        O Encarregado pelo Tratamento de Dados Pessoais (DPO) é o responsável pela proteção dos dados pessoais tratados
        pela Isha. Para assuntos relacionados à LGPD ou para o exercício dos direitos previstos no art. 18 da Lei nº
        13.709/2018 pelos titulares de dados, o DPO pode ser contatado pelo e-mail dpo@omens.com.br.
      </Body2>
      <Body2 color="alabaster">2025 © Isha. Todos os direitos reservados.</Body2>
    </SectionStack>
  )
}

export default CompanyInfoSectionIsha
